import assign from 'lodash/assign';
import isEmpty from 'lodash/isEmpty';
import toPlainObject from 'lodash/toPlainObject';

import Filter from '../models/Filter';
import type { FilterType } from '../types/Filters';
import filterUtils from './filterUtils';

type QueryObjectType = {
  [key: string]: string | Array<string>;
};

export const filterFromQuery = (query: QueryObjectType): FilterType => {
  const filterFromUrl = filterUtils.queryObjToFilterObj(toPlainObject(query));
  const filter = isEmpty(filterFromUrl) ? new Filter() : new Filter(assign(toPlainObject(new Filter()), filterFromUrl));
  return toPlainObject(filter);
};
